import React, { Component } from "react";
import AsyncImage from "../AsyncImage";
import ReactPlayer from "react-player";
import LazyLoad from "react-lazyload";
import Link from 'gatsby-link'

import FullScreenContainer from "./FullScreen/FullScreenContainer";

import styles from "./galerija.module.css";

const isImage = contentType => {
  return contentType.indexOf("image") > -1;
};

class Galerija extends Component {
  state = {
    showFullScreen: false
  };

  showFullScreen = index => {
    this.setState({
      activeIndex: index,
      showFullScreen: true
    });
  };

  closeFullScreen = () => {
    this.setState({
      activeIndex: 0,
      showFullScreen: false
    });
  };

  render() {
    const { pathContext } = this.props;
    const { activeIndex, showFullScreen } = this.state;

    return <div className={styles.mainContainer}>
      <div className={styles.imagesContainer}>
        {showFullScreen && pathContext.media && (
          <FullScreenContainer
            images={pathContext.media}
            activeIndex={activeIndex}
            closeFullScreen={this.closeFullScreen}
          />
        )}
        {pathContext.media &&
          pathContext.media.map((image, i) => {
            return (
              <div key={image.file.url} className={styles.imageContainer}>
                {isImage(image.file.contentType) ? (
                  <div onClick={() => this.showFullScreen(i)}>
                    <AsyncImage
                      imageUrl={image.file.url}
                      alt={image.description}
                      className={styles.image}
                      imageClassName={styles.image}
                      placeholderColor="#ecf0f1"
                    />
                  </div>
                ) : (
                    <LazyLoad height="100%" once={true}>
                      <span>
                        <ReactPlayer
                          width="100%"
                          height="100%"
                          url={image.file.url}
                          controls={true}
                        />
                      </span>
                    </LazyLoad>
                  )}
              </div>
            );
          })}
      </div>
      <Link className={styles.back} to="/klub/galerija">
        Nazaj na galerije
              </Link>
    </div>
  }
}

export default Galerija;



// WEBPACK FOOTER //
// ./src/components/Galerija/index.js